{
  "credits": {
    "ledger": {
      "signupGift": "Willkommensgeschenk",
      "topUp": "Aufladung: {{amount}} {{coin}}",
      "storePurchase": "Kauf von {{amount}} {{coin}} über {{store}}",
      "giftCode": "Geschenkcode {{code}}",
      "prize": "Gewinn beim Glücksrad",
      "gift": "Geschenktes Guthaben",
      "stores": {
        "bazaar": "Cafe Bazaar"
      }
    }
  }
}
